import * as React from 'react';

import { getParkingTypes } from './helpers';
import { FOfferType, NonEmptyArray } from '../../../../../JsonQuery';
import { EParkingType } from '../../../../../api-models/common/json_query';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { Filter } from '../common/Filter';

interface IParkingProps {
  offerType: FOfferType;
  value: NonEmptyArray<EParkingType> | null;
  onChange(value: NonEmptyArray<EParkingType> | null): void;
}

export const Parking: React.FC<IParkingProps> = ({ offerType, value, onChange }) => {
  const parkingTypes = getParkingTypes(offerType);

  return (
    <Filter id="advancedFilter_parking" label="Парковка">
      <CheckboxButtonGroupUnselectable options={parkingTypes} value={value} onChange={onChange} />
    </Filter>
  );
};
